import { ColDef } from "ag-grid-community";
import { ISetFilterParams } from "ag-grid-enterprise";

/**
 * Set column type for the ag-grid.
 */
export const SetColumn: ColDef = {
	filter: "agSetColumnFilter",
	floatingFilter: true,
	filterParams: {
		defaultToNothingSelected: true,
		keyCreator: (params: any) => params.value.value,
		valueFormatter: (params: any) => params.value.label,
	} as ISetFilterParams,
	valueFormatter(params) {
		if (params.value == undefined) return "";

		let values: Record<string, string> = {};
		if ("refData" in params.colDef) {
			values = params.colDef.refData as Record<string, string>;
		} else if (params.colDef.context?.values != undefined) {
			// Where AppDataGrid parks the backend's `values`: AG Grid rejects it as a colDef property.
			values = params.colDef.context.values as Record<string, string>;
		} else if ("values" in params.colDef) {
			// Grids that hand the raw server column to AG Grid unfiltered (buildGridColumns,
			// AppOrderRowBulkEditGrid) still carry it at the top level.
			values = params.colDef.values as Record<string, string>;
		} else {
			values = params.colDef.filter;
		}

		if (Array.isArray(params.value)) {
			return params.value.map((it) => values[it]).join(", ");
		}

		if (typeof params.value == "string") {
			return values[params.value];
		}

		return "";
	},
};
